<template>
	<div class="database">
		<h1 v-if="name && action_head_i == -1">Table {{ table }}</h1>

		<div v-if="change_table">
			<label class="form-label">Données</label>
			<v-select
				v-model="table"
				:options="tables"
				@input="updateTable" />
			<br /><br />
		</div>

		<div v-show="table">

			<div v-show="list_actions_head.length > 0">
				<b-button
					variant="link"
					v-show="action_head_i != -1"
					@click="action_head_i = -1"
					><i class="fas fa-arrow-left"></i
				></b-button>
				<span v-if="action_head_i == -1">
					<span
						v-for="(action_head, key) in list_actions_head"
						:key="action_head.name">
						&nbsp;<b-button @click="action_head_i = key">{{
							action_head.name
						}}</b-button>
					</span>
					<br /><br />
				</span>
			</div>

			<div v-if="action_head_i != -1">
				<iframe
					:src="list_actions_head[action_head_i].url"
					frameborder="0"
					scrolling="no"
					style="overflow: hidden; width: 100%"
					:height="height - 100 + 'px'"
					width="100%">
				</iframe>
			</div>

			<div v-show="action_head_i == -1">
				<datalist id="my-list-id">
					<option></option>
					<option v-for="item in items" :key="item">
						{{ item }}
					</option>
				</datalist>


				<label class="form-label">Filtrer</label>
				<div :id="'builder' + id"></div>


				<label class="form-label">Requète générée</label>
				<b-form-input v-show="!rules_buttons || rules_buttons.search_bar == true"
					v-model="value_request"
					list="my-list-id"></b-form-input>

				<hr>

				<div class="d-flex align-items-center mb-2">
					<b-button variant="success" @click="updatePage(null)"
						>Executer requête</b-button
					>&nbsp; <b-button @click="reset">Reset</b-button>&nbsp;
					<b-button v-b-modal="'modal' + id"
						><i class="fas fa-eye"></i></b-button
					>&nbsp;
					<b-button v-b-modal="'modal-colonne' + id">Colonnes id</b-button>&nbsp;
					<b-button :variant="select == '*' ? 'secondary' : 'primary'" v-b-modal="'modal-select' + id">Select</b-button>&nbsp;
					<b-button v-if="default_visible == false && visible == true" @click="visible = false"><i class="fas fa-eye-slash"></i> données</b-button>
					<b-button v-if="default_visible == false && visible == false" @click="visible = true"><i class="fas fa-eye"></i> données</b-button>
					&nbsp;
					<b-button v-b-toggle="'collapse-config-' + id">
						<i class="fas fa-bookmark"></i> Config
					</b-button>&nbsp;
					<b-modal :hide-footer="true" :id="'modal' + id" title="Requête">
						<p>{{ request }}</p>
					</b-modal>

					<div
						class="mr-2"
						:class="noLimitQuery ? 'opacity-25' : ''">
						Limite 100
					</div>
					<b-form-checkbox
						v-model="noLimitQuery"
						switch/>
					<div :class="!noLimitQuery ? 'opacity-25' : ''">
						Pas de limite
					</div>
				</div>

				<b-modal
					:hide-footer="true"
					:id="'modal-colonne' + id"
					title="Colonnes id">
					<b-form-checkbox-group
						v-model="columns_selected"
						:options="options_columns"
						stacked
						@change="update"></b-form-checkbox-group>
				</b-modal>

				<b-modal
					:hide-footer="true"
					:id="'modal-select' + id"
					title="Select">
					<b-input v-model="select"></b-input>
				</b-modal>

				<b-collapse :id="'collapse-config-' + id" class="mt-2 mb-2">
					<config-save-load
						ref="configSaveLoad"
						type="table"
						:context="table ? 'table - ' + table : null"
						:value="{}"
						:get-value-fn="_getConfigSnapshot"
						@input="_loadConfigSnapshot" />
					<b-form-checkbox v-model="useDefaultChart" class="mt-1 small">
						Charger le graphique par défaut
					</b-form-checkbox>
				</b-collapse>

				<hr/>

				<p class="ml-4">{{ text }}</p>

				<b-collapse v-model="visible" :id="'collapse' + id">
					<b-tabs class="mt-2" content-class="mt-3">
						<b-tab title="Requête">
							<!-- * checkbox pour le no-limit -->
							<edit_tabulator
								:extern_file="false"
						:filename="local_filename || filename || (table ? table + '.csv' : null)"
								@add_row="add_row"
								@delete_row="delete_row"
								@update_row="update_row"
								ref="main_data"></edit_tabulator>

							<br />

							<div v-if="edit">
								<b-button
									v-if="(!rules || rules.create == true) && (!rules_buttons || rules_buttons.new_line == true)"
									v-b-modal="'modal-add' + id"
									>nouvelle ligne</b-button
								>

								<b-modal
									:hide-footer="true"
									:id="'modal-add' + id"
									size="xl"
									title="Nouvelle ligne">
									<div
										v-for="column in new_columns"
										:key="column.name">
										<span
											>{{ column.name }}
											{{ column.description }}</span
										>
										<b-form-checkbox
											v-model="column.checked"></b-form-checkbox>
										<b-form-input
											v-model="column.value"></b-form-input>
									</div>
									&nbsp;
									<b-button @click="addLine">Valider</b-button>
									<br />
									{{ result_add_line }}
								</b-modal>

								&nbsp;
								<b-button
									v-if="(
										!rules ||
										rules.update == true ||
										rules.delete == true ||
										rules.create == true) && (!rules_buttons || rules_buttons.update == true)
									"
									v-b-toggle="'modal-update' + id"
									>mise à jour</b-button
								>

								<!-- &nbsp;
								<b-button
									v-if="(!rules || rules.delete == true) && (!rules_buttons || rules_buttons.delete_from_csv == true)"
									v-b-toggle="'collapse-delete' + id"
									>delete à partir d'un csv</b-button
								> -->

								&nbsp;
								<b-button
									v-if="(!rules || (rules.update == true && rules.create == true)) && (!rules_buttons || rules_buttons.update_from_csv == true)"
									v-b-toggle="'collapse-update-csv' + id"
									>import csv</b-button
								>

								&nbsp;
								<b-button
									v-if="(
										!rules ||
										(rules.update == true && rules.delete == true)) && (!rules_buttons || rules_buttons.fusion == true)
									"
									v-b-toggle="'collapse-fusion' + id"
									>fusion</b-button
								>

								<br /><br />

								<b-collapse :id="'modal-update' + id">
									<b-button v-on:click="update_db"
										>Update
										{{ update_tabulator.length }} lignes</b-button
									>
									<br /><br />
									<b-progress
										:value="counter_update"
										animated></b-progress>
									<br /><br />

									<edit_tabulator
										:extern_file="true"
										ref="ref_update_tabulator"></edit_tabulator>

									<b-button variant="link" v-b-toggle="'collapse-update-column' + id">Liste des colonnes</b-button>

									<b-collapse :id="'collapse-update-column' + id">
										<b-form-checkbox-group
											v-model="update_columns"
											:options="
												options_columns
											"></b-form-checkbox-group>
									</b-collapse>

									<!-- <p class="pre-formatted">{{ result_update }}</p> -->
								</b-collapse>

								<b-collapse :id="'collapse-delete' + id">
									<h3>Delete</h3>
									<edit_tabulator
										ref="edit_tabulator_delete"></edit_tabulator>
									<br />
									<b-button @click="delete_lines()"
										><i class="fas fa-trash"></i> Lignes</b-button
									>
									<br /><br />
									<b-progress
										v-if="counter_delete"
										:value="counter_delete"
										animated></b-progress>
									<p class="pre-formatted">{{ result_delete }}</p>
								</b-collapse>

								<b-collapse :id="'collapse-update-csv' + id">
									<h3>Import csv</h3>

									Nouvelle ligne <b-checkbox style="display: inline" v-model="update_config_create" />
									Mise à jour <b-checkbox style="display: inline" v-model="update_config_update" />

									<br /><br />

									<edit_tabulator @update="update_import" ref="edit_tabulator_update_csv"></edit_tabulator>
									<br />
									<b-container style="margin: 0; padding: 0; max-width: none;">
										<b-row>
											<b-col :cols="3">
												Colonne
											</b-col>
											<b-col :cols="3">
												Colonne table
											</b-col>
											<b-col :cols="3">
												Colonne identifiant
											</b-col>
										</b-row>
										<b-row v-for="(column, key) in update_config" :key="key">
											<b-col :cols="3">
												{{ column.column }}
											</b-col>
											<b-col :cols="3">
												<v-select v-model="column.column_db" :options="options_columns"></v-select>
											</b-col>
											<b-col :cols="3">
												<b-checkbox v-show="column.column_db" v-model="column.unique" />
											</b-col>
										</b-row>
									</b-container>
									<br />
									<b-button @click="update_csv">Exécuter</b-button
									>
									<br /><br />
									{{ update_status }}

									<edit_tabulator v-show="update_status" ref="edit_tabulator_update_csv_result" :extern_file="false"></edit_tabulator>
								</b-collapse>

								<b-collapse :id="'collapse-fusion' + id">
									<h3>Fusion</h3>

									<b-form-select
										v-model="fusion_columns_id"
										:options="options_columns"
										multiple
										:select-size="5"></b-form-select>
									<br /><br />
									<b-button @click="calculate_fusion"
										>Calculer les modifications</b-button
									>
									<br /><br />
									<h4>Lignes qui vont être mises à jour</h4>

									<edit_tabulator
										:extern_file="false"
										v-show="tabulator_fusion_update.length > 0"
										ref="edit_tabulator_fusion_update"></edit_tabulator>
									<br />
									<h4>Lignes qui vont être supprimées</h4>

									<edit_tabulator
										:extern_file="false"
										v-show="tabulator_fusion_delete.length > 0"
										ref="edit_tabulator_fusion_delete"></edit_tabulator>
									<br /><br />
									<b-button @click="apply_fusion"
										>Appliquer les modifications</b-button
									>

									<div v-if="counter_update_csv">
										<p>Update</p>
										<b-progress
											v-if="counter_update_csv"
											:value="counter_update_csv"
											animated></b-progress>
										<p class="pre-formatted">
											{{ result_update_csv }}
										</p>
									</div>

									<div v-if="counter_delete">
										<p>Delete</p>
										<b-progress
											v-if="counter_delete"
											:value="counter_delete"
											animated></b-progress>
										<p class="pre-formatted">{{ result_delete }}</p>
									</div>
								</b-collapse>

								<br />
								<div v-if="!rules || rules.actions">
									<span
										v-for="action in list_actions"
										:key="action.name">
										&nbsp;<b-button
											variant="success"
											v-on:click="
												start_treatment(
													action.tags,
													action.project,
													action.type,
													false
												)
											"
											>{{ action.name }}
											<span v-if="action.line"
												>({{
													tabulator_data.length > 1
														? tabulator_data.length +
														" lignes"
														: tabulator_data.length +
														" ligne"
												}})</span
											></b-button
										>
									</span>
								</div>
								<treatment
									v-show="launch"
									ref="myTreatment"></treatment>
							</div>
						</b-tab>
						<b-tab v-if="!rules_buttons || rules_buttons.structure == true"
							title="Structure"
							@click="
								() => (structureLength = tableStructureData.length)
							">
							<edit_tabulator
								:extern_file="false"
								ref="structure_tabulator"></edit_tabulator>
						</b-tab>
						<b-tab v-if="description" title="Description">
							<p v-html="description"></p>
						</b-tab>
						<b-tab v-if="data.length > 0" title="Graphique">
							<chart-display
								ref="chartDisplay"
								:rows="data"
								:config="chartConfig"
								:editable="true"
								:table-name="'table - ' + table"
								:table-structure="tableStructureData"
								:auto-load-enabled="useDefaultChart"
								@config-change="chartConfig = $event" />
						</b-tab>
					</b-tabs>
				</b-collapse>
			</div>

		</div>
	</div>
</template>

<script>
	var clone = require("clone");

	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	import $ from "jquery";
	import * as json2csv from "json2csv";
	import uniqueId from "lodash.uniqueid";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	import store from "../store";
	import create from "./Create.vue";
	import users from "../services/users.js";
	import workers from "../services/workers.js";
	import treatments from "../services/treatments.js";
	import treatment from "../components/treatment.vue";
	import database_service from "../services/database.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import ChartDisplay from "../components/ChartDisplay.vue";
	import ConfigSaveLoad from "../components/ConfigSaveLoad.vue";
	import { defaultChartConfig } from "../components/ChartConfigForm.vue";

	export default {
		name: "database",
		components: {
			edit_tabulator: edit_tabulator,
			ChartDisplay,
			ConfigSaveLoad,
			treatment: treatment,
			database: () => import('./database.vue')
		},
		props: {
			edit: {
				default: true,
				type: Boolean,
			},
			name: {
				default: true,
				type: Boolean,
			},
			change_table: {
				default: false,
				type: Boolean
			},
			start_table: {
				default: ""
			},
			default_visible: {
				default: true,
				type: Boolean
			},
			filename: {
				default: null,
				type: String
			},
			// jwt d'un utilisateur simulé ("tester en tant que"), fourni par Validation.vue quand
			// ce composant est utilisé comme source de données de test. Sans effet sur les actions
			// d'écriture (le service database.js l'ignore pour tout ce qui n'est pas select/show).
			test_jwt: {
				default: null
			}
		},
		data() {
			return {
				query: {},
				table: this.$route.params.table || this.start_table || "",
				tables: [],
				data: [],
				chartConfig: defaultChartConfig(),
				useDefaultChart: true,
				fields: [],
				description: "",
				tabulator_data: [],
				tabulator_options: {
					columns: [],
				},
				count: 0,
				items: ["order by id limit 10", "doublons"],
				text: "",
				value: "",
				value_request: "",
				columns: [],
				rules_buttons: "",
				rules_editor: "",
				rules_sql: "",
				event: "",
				request: "",
				id: uniqueId(""),
				new_columns: [],
				options_columns: [],
				columns_selected: [],
				result_add_line: "",
				result_update: "",
				result_delete: "",
				result_update_csv: "",
				counter_update: 0,
				counter_delete: 0,
				counter_update_csv: 0,
				input_menu: "",
				name_column: "",
				local_filename: "",
				fusion_columns_id: [],
				tabulator_fusion_update: [],
				tabulator_fusion_delete: [],
				launch: false,
				client_details: {},
				list_actions: [],
				list_actions_head: [],
				column_id: "id",
				rules: null,
				update_columns: [],
				update_tabulator: [],

				height: 1000,
				action_head_i: -1,

				noLimitQuery: false,
				tableStructureData: [],
				structureLength: 0,
				conditionsOpen: false,
				select: "*",
				visible: true,
				update_status: "",
				update_type: "",
				update_config: {},
				update_config_create: false,
				update_config_update: true 
			};
		},
		computed: {
			tabulator_data_length: function () {
				return this.tabulator_data.length;
			},
			structureDataLength: function () {
				return this.tableStructureData.length;
			},
		},
		mounted: async function () {
			this.$loadScript(
				"https://oss.sheetjs.com/sheetjs/xlsx.full.min.js"
			);

			if (
				store.state.user.rules &&
				store.state.user.rules.database == "désactivé"
			) {
				this.$router.push({ name: "profile" });
			}

			this.visible = this.default_visible;

			var user = store.state.user;
            var response = await users.getSelf(true);
			this.client = response.client;
			this.client_details = this.client.details;

			var tables = [];
			if (this.client.details && this.client.details.tables)
				tables = this.client.details.tables;

			if (tables && tables.length > 0) {
				for (var i = 0; i < tables.length; i++) {
					this.tables.push(tables[i].name);
				}
			}

			var tables = [];
			if (this.client.details && this.client.details.tables)
				tables = this.client.details.tables;

			this.database_tables = null;
			if (
				user.rules != null &&
				user.rules.database == "certaines tables"
			) {
				this.database_tables = {};

				for (
					var i = 0;
					i < user.rules.database_tables.length;
					i++
				) {
					this.database_tables[
						user.rules.database_tables[i].name
					] = user.rules.database_tables[i];
				}
			}

			this.tables = [];
			if (tables && tables.length > 0 && this.database_tables) {
				for (var i = 0; i < tables.length; i++) {
					if (
						tables[i] && !tables[i].hide && this.database_tables[tables[i].name] &&
						(!this.database_tables || !this.database_tables[tables[i].name].hide) &&
						(!this.database_tables ||
							(this.database_tables[tables[i].name] &&
								this.database_tables[tables[i].name].read))
					)
					{
						this.tables.push(tables[i].name);
					}
				}
            }

			if (tables && tables.length > 0 && (user.rules == null || user.rules.database == "activé")) {
				for (var i = 0; i < tables.length; i++) {
					this.tables.push(tables[i].name);
				}
			}

			// Récupérer le paramètre query de l'URL
			if (this.$route.query.query) {
				this.value_request = this.$route.query.query;
			}

			if ((this.table && this.name) || this.start_table)
			{
				//console.log("mounted")
				this.init();
			}

		},
		watch: {
			$route() {
				this.table = this.$route.params.table;
				this.value_request = "";
				this.chartConfig = defaultChartConfig();
				//console.log("route")
				this.init();
			},
			tabulator_data: {
				deep: true,
				handler() {
					this.$emit("update", this.tabulator_data);
				},
			},
			noLimitQuery(newVal, oldVal) {
				if (
					newVal === true &&
					!this.value_request.includes("no limit")
				) {
					this.value_request += "no limit";
					// this.updatePage(null);
				} else {
					this.value_request = this.value_request.replace(
						"no limit",
						""
					);
					// this.updatePage(null);
				}
			},
		},
		methods: {
			async updateTable() {
				var self = this;
				//console.log("update table")
				this.init(self.table);
			},
			async setStructureData() {
				let data = await database_service.get("show", this.table, undefined, this.test_jwt);

				var exemple = await database_service.get("SELECT", this.table, {
					end: "ORDER BY id DESC LIMIT 1",
				}, this.test_jwt);
				if (exemple.length > 0) {
					exemple = exemple[0];

					for (var i = 0; i < data.length; i++) {
						data[i].Exemple = exemple[data[i].Field];
					}
				}

				this.tableStructureData = data;

				this.$refs.structure_tabulator.set_data(
					this.tableStructureData, ["Field", "Type", "Comment", "Exemple", "Null", "Key", "Default", "Extra"]
				);
				this.$refs.structure_tabulator.set_pagination(
					this.tableStructureData.length
				);
			},
			save() {
				//console.log("save")
				return {
					rules: this.rules_editor,
					event: this.event,
					rules_sql: this.rules_sql,
					columns_selected: this.columns_selected,
					table: this.table,
					select: this.select
				};
			},
			_getConfigSnapshot() {
				return { ...this.save(), chartConfig: { ...this.chartConfig }, useDefaultChart: this.useDefaultChart };
			},
			async _loadConfigSnapshot(data) {
				if (!data) return;
				if (data.useDefaultChart !== undefined) this.useDefaultChart = data.useDefaultChart;
				await this.load(data, data.table || this.table);
				await this.$nextTick();
				if (this.useDefaultChart) {
					// Réappliquer la config graphique par défaut (load() l'a écrasée avec le snapshot)
					if (this.$refs.chartDisplay) await this.$refs.chartDisplay.autoLoad();
				} else {
					// Effacer le nom dans la barre chart
					if (this.$refs.chartDisplay) this.$refs.chartDisplay.resetConfig();
				}
			},
			async load(data, table) {
				console.log("load")
				if (!table && data.table)
					table = data.table;
				console.log(data)
				if (data.rules)
					this.rules_editor = data.rules;
				await this.init(table, false, data.rules ? data.rules : null);
				if (data.rules_sql)
					this.rules_sql = data.rules_sql;
				this.event = data.event;
				this.value_request = data.event;
				this.columns_selected = data.columns_selected;
				this.select = data.select || "*"
				if (data.chartConfig) this.chartConfig = { ...defaultChartConfig(), ...data.chartConfig };
				await this.updatePage(this.value_request);
				/*try {
					$("#builder" + this.id).queryBuilder(
						"setRules",
						data.rules
					);
				} catch (err) {}*/
			},
			async start_treatment(tags, project, _type) {
				var self = this;

				var name_file_tabulator = this.table + ".csv";
				var tabulator_data_csv =
					await this.$refs.main_data.get_data_blob();

				var type = "import";
				if (_type) type = _type;

				this.launch = true;

				treatments
					.create(
						project,
						null,
						tabulator_data_csv,
						name_file_tabulator,
						tags,
						type
					)
					.then((res) => {
						//this.$router.push({ name: 'treatment', params: { id: res.treatment.uid } })
						this.$refs.myTreatment.start(
							res.treatment.uid,
							true,
							1000
						);
					})
					.catch((err) => {
						console.log("error : " + err);
						this.$notify({
							group: "info",
							title: err.response.data.msg,
							type: "error",
						});
					});
			},
			update_data_selection(data) {
				this.tabulator_data = data;
			},
			update_data(id, data) {
				this.tabulator_data = data;
			},
			delete_row(id, row) {
				if (this.rules && !this.rules.delete) return;
				var index = row.getIndex();
				var data = row.getData();
				data.type_action = "Supprimer";
				this.update_tabulator.push(data);
				this.$refs.ref_update_tabulator.set_data(this.update_tabulator);
			},
			add_row(id, row) {
				var index = row.getIndex();
				var data = row.getData();
				data.type_action = "Ajouter";
				this.update_tabulator.push(data);
				this.$refs.ref_update_tabulator.set_data(this.update_tabulator);
			},
			update_row(id, row) {
				console.log("db - update_row")
				var index = row.getIndex();
				var data = row.getData();
				var _data = null;
				for (var i = 0; i < this.update_tabulator.length; i++) {
					if (index == this.update_tabulator[i][this.column_id]) {
						var _data = this.update_tabulator[i];
						data.type_action = _data.type_action;
						this.update_tabulator[i] = data;
						break;
					}
				}
				if (_data == null) {
					data.type_action = "Modifier";
					this.update_tabulator.push(data);
				}
				this.$refs.ref_update_tabulator.set_data(this.update_tabulator);
			},
			get_data: function () {
				return this.tabulator_data;
			},
			get_data_blob: async function () {
				var str_csv = json2csv.parse(this.tabulator_data, {
					fields: Object.keys(this.tabulator_data.length > 0 ? this.tabulator_data[0] : []),
					fieldNames: Object.keys(this.tabulator_data.length > 0 ? this.tabulator_data[0] : []),
				});

				return new Blob([str_csv], {
					type: "text/plain",
				});
			},
			get_data_files: async function (all_files = true) {
				if (!all_files) return [];

				var str_csv = json2csv.parse(this.tabulator_data, {
					fields: Object.keys(this.tabulator_data[0]),
					fieldNames: Object.keys(this.tabulator_data[0]),
				});

				return [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];
			},
			set_data: function (data, name_columns) {
				if (!Array.isArray(data) || data.length == 0) data = [{}];

				var fields = Object.keys(data[0]);
				var columns = [];
				for (var i = 0; i < fields.length; i++) {
					if (
						!name_columns ||
						(name_columns && name_columns.includes(fields[i]))
					)
						columns.push({
							title: fields[i],
							field: fields[i],
							editor: "textarea",
							headerContextMenu: this.headerContextMenu,
						});
				}
				if (this.option_delete) {
					columns.push({
						formatter: "buttonCross",
						width: 40,
						align: "center",
						cellClick: function (e, cell) {
							cell.getRow().delete();
						},
					});
				}
				this.tabulator_data = data;
				this.$refs.main_data.set_data(this.tabulator_data);
				this.tabulator_options.columns = columns;
			},
			calculate_fusion: async function () {
				var data = {};
				this.tabulator_fusion_update = [];
				this.tabulator_fusion_delete = [];
				for (var i = 0; i < this.tabulator_data.length; i++) {
					var id = "";
					for (var j = 0; j < this.fusion_columns_id.length; j++) {
						id += this.tabulator_data[i][this.fusion_columns_id[j]];
					}
					if (data[id]) data[id].push(this.tabulator_data[i]);
					else data[id] = [this.tabulator_data[i]];
				}
				var keys = Object.keys(data);
				for (var i = 0; i < keys.length; i++) {
					if (data[keys[i]].length > 1) {
						var obj = clone(data[keys[i]][0]);
						for (var j = 0; j < data[keys[i]].length; j++) {
							if (j > 0) {
								for (
									var k = 0;
									k < this.options_columns.length;
									k++
								) {
									if (
										data[keys[i]][j][
											this.options_columns[k]
										] !== "" &&
										data[keys[i]][j][
											this.options_columns[k]
										] !== null
									)
										obj[this.options_columns[k]] =
											data[keys[i]][j][
												this.options_columns[k]
											];
								}
							}
							if (j + 1 != data[keys[i]].length)
								this.tabulator_fusion_delete.push(
									data[keys[i]][j]
								);
						}
						this.tabulator_fusion_update.push(obj);
					}
				}
				this.$refs.edit_tabulator_fusion_update.set_data(
					this.tabulator_fusion_update
				);
				this.$refs.edit_tabulator_fusion_delete.set_data(
					this.tabulator_fusion_delete
				);
			},
			apply_fusion: async function () {
				this.update_lines_csv(true);
				this.delete_lines(true);
			},
			update_import()
			{
				var update_config = {};

				var data = this.$refs.edit_tabulator_update_csv.get_data();
				if (data.length > 0)
				{
					var columns = Object.keys(data[0]);
					for (var i = 0; i < columns.length; i++)
					{
						if (this.update_config[columns[i]])
							update_config[columns[i]] = this.update_config[columns[i]];
						else
						{
							update_config[columns[i]] = {
								column: columns[i],
								column_db: this.options_columns.includes(columns[i]) ? columns[i] : "",
								unique: false
							}
						}
					}
				}

				this.update_config = update_config;
			},
			async update_csv()
			{
				if (!this.update_config_create && !this.update_config_update)
					return

				this.update_status = "En cours";
				var csv_data = this.$refs.edit_tabulator_update_csv.get_data();
				var str_csv = json2csv.parse(csv_data, {
					fields: Object.keys(csv_data[0]),
					fieldNames: Object.keys(csv_data[0]),
				});
				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var columns = [];
				var uniq_columns = [];

				var keys = Object.keys(this.update_config);
				for (var i = 0; i < keys.length; i++)
				{
					if (this.update_config[keys[i]].column_db)
					{
						columns.push({colonne: this.update_config[keys[i]].column, mapping: this.update_config[keys[i]].column_db});
						if (this.update_config[keys[i]].unique)
							uniq_columns.push(this.update_config[keys[i]].column_db);
					}
				}

				var parameters = {
					"token": "",
					"mysql2": false,
					"table": this.table,
					"colonnes": columns,
					"colonnes_unique": uniq_columns,
					"response_column": "response"
				};

				if (this.update_config_create && this.update_config_update)
				{
					parameters.type = "mettre à jour";
					parameters.create = true;
				}
				if (!this.update_config_create && this.update_config_update)
				{
					parameters.type = "mettre à jour";
					parameters.create = false;
				}
				if (this.update_config_create && !this.update_config_update)
				{
					parameters.type = "insérer";
				}
				
				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", "base de données");
				formData.append("parameters", JSON.stringify(parameters));

				console.log(csv_data);
				console.log(parameters)

				var results = await workers.test(formData);

				var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				
				data = this.$papa.parse(data, { header: true });
				data = data.data;

				this.$refs.edit_tabulator_update_csv_result.set_data(data);

				if (results.data.error)
					this.update_status = "Erreur : " + results.data.error;
				else
					this.update_status = "Terminé";

				this.updatePage();
			},
			update_lines_csv: async function (csv) {
				//console.log("update_lines_csv")
				if (csv)
					var csv_data =
						this.$refs.edit_tabulator_fusion_update.get_data();
				else
					var csv_data =
						this.$refs.edit_tabulator_update_csv.get_data();

				//console.log(csv_data)

				this.counter_update_csv = 0;
				this.result_update_csv = "";

				var columns = Object.keys(csv_data[0]);
				columns = columns.filter(function (e) {
					return (
						e !== "id" &&
						e !== "id_compare" &&
						e !== "i_doublons" &&
						e !== "nb_doublons"
					);
				});

				for (var i = 0; i < csv_data.length; i++) {
					if (csv_data[i].id || csv_data[i].id === 0) {
						var type = "update";
						var params = {};
						var request = "";
						for (var j = 0; j < columns.length; j++) {
							if (j > 0) request += ",";
							var data = csv_data[i][columns[j]];
							if (data == null || data == "null") data = "NULL";
							else if (typeof data == "string")
								data = '"' + data.replace(/"/g, '\\"') + '"';
							request += "`" + columns[j] + "` = " + data + " ";
						}
						params.set = request;
						params.where =
							this.column_id +
							' = "' +
							csv_data[i][this.column_id] +
							'"';
					} else {
						var type = "insert into";
						var params = {
							data: csv_data[i],
							columns: columns,
						};
					}
					var response = await database_service.get(type, this.table, params);
					this.result_update_csv =
						"ligne " +
						(i + 1) +
						"/" +
						csv_data.length +
						" : " +
						JSON.stringify(response) +
						"\n" +
						this.result_update_csv;
					//this.result_update_csv = "ligne " + (i + 1) + "/" + csv_data.length + " : " + request + '\n' + this.result_update_csv;
					this.counter_update_csv = ((i + 1) / csv_data.length) * 100;
				}
				this.updatePage();
			},
			delete_lines: async function (csv) {
				//console.log("delete_lines")
				if (csv)
					var csv_data =
						this.$refs.edit_tabulator_fusion_delete.get_data();
				else var csv_data = this.$refs.edit_tabulator_delete.get_data();

				this.counter_delete = 0;
				this.result_delete = "";
				for (var i = 0; i < csv_data.length; i++) {
					if (csv_data[i][this.column_id]) {
						var response = await database_service.get(
							"delete",
							this.table,
							{
								where:
									"`" +
									this.column_id +
									"` = '" +
									csv_data[i][this.column_id] +
									"'",
							}
						);
						this.result_delete =
							"ligne " +
							(i + 1) +
							"/" +
							csv_data.length +
							" : " +
							JSON.stringify(response) +
							"\n" +
							this.result_delete;
						this.counter_delete = ((i + 1) / csv_data.length) * 100;
					}
				}
				this.updatePage();
			},
			update_db: async function () {
				//console.log("update_db")

				var data = this.$refs.ref_update_tabulator.get_data();
				var data_columns = data.length > 0 ? Object.keys(data[0]) : [];

				if (!data_columns.includes(this.column_id))
				{
					this.$notify({
						group: "info",
						title: "La colonne d'id " + this.column_id + " n'est pas présente.",
						type: "error",
					});

					this.updatePage();
					return;
				}

				var self = this;
				var columns = this.update_columns;
				var columns = columns.filter(function (e) {
					return e !== self.column_id && e !== "type_action" && data_columns.includes(e);
				});

				for (var i = 0; i < data.length; i++) {
					for (var j = 0; j < columns.length; j++)
					{
						if (data[i][columns[j]] == "null")
							data[i][columns[j]] = null;
					}
					if (data[i]["type_action"] == "Modifier") {
						var request = "";
						for (var j = 0; j < columns.length; j++) {
							if (j > 0) request += ",";
							var data_cell = data[i][columns[j]];
							if (typeof data_cell == "string")
								data_cell =
									'"' + data_cell.replace(/"/g, '\\"') + '"';
							if (data_cell == null)
								data_cell = "NULL";
							request +=
								"`" + columns[j] + "` = " + data_cell + " ";
						}
						var response = await database_service.get(
							"update",
							this.table,
							{
								set: request,
								where:
									this.column_id +
									' ="' +
									data[i][this.column_id] +
									'"',
							}
						);
						this.result_update =
							"ligne " +
							(i + 1) +
							"/" +
							data.length +
							" : " +
							JSON.stringify(response) +
							"\n" +
							this.result_update;
						this.counter_update = ((i + 1) / data.length) * 100;
					} else if (data[i]["type_action"] == "Supprimer") {
						var response = await database_service.get(
							"delete",
							this.table,
							{
								where:
									"`" +
									this.column_id +
									"` = '" +
									data[i][this.column_id] +
									"'",
							}
						);
						this.result_update =
							"ligne " +
							(i + 1) +
							"/" +
							data.length +
							" : " +
							JSON.stringify(response) +
							"\n" +
							this.result_update;
						this.counter_update = ((i + 1) / data.length) * 100;
					} else if (data[i]["type_action"] == "Ajouter") {
						var response = await database_service.get(
							"insert into",
							this.table,
							{ data: data[i], columns: columns }
						);
						this.result_update =
							"ligne " +
							(i + 1) +
							"/" +
							data.length +
							" : " +
							JSON.stringify(response) +
							"\n" +
							this.result_update;
						this.counter_update = ((i + 1) / data.length) * 100;
					}
				}

				this.update_tabulator = [];
				this.$refs.ref_update_tabulator.set_data(this.update_tabulator);
				this.updatePage();
			},
			addLine: async function () {
				var columns = [];
				var values = {};
				for (var i = 0; i < this.new_columns.length; i++) {
					if (this.new_columns[i].checked) {
						columns.push(this.new_columns[i].name);
						values[this.new_columns[i].name] =
							this.new_columns[i].value;
					}
				}

				this.result_add_line = await database_service.get(
					"insert into",
					this.table,
					{ data: values, columns: columns }
				);
			},
			async init(table, update = true, rules = null) {
				var self = this;
				var id = this.id;

				if (table) this.table = table;

				if (update) {
					this.chartConfig = defaultChartConfig();
				}

				if (!this.table)
					return;

				if (this.database_tables && this.database_tables[this.table].hide)
				{
					this.$router.push({ name: "profile" });
				}

				if (this.$refs.ref_update_tabulator) {
					this.update_tabulator = [];
					this.$refs.ref_update_tabulator.set_data(
						this.update_tabulator
					);
				}

				this.rules = null;

				this.rules_buttons = null;
				if (store.state.user.rules && store.state.user.rules.database_buttons)
					this.rules_buttons = store.state.user.rules.database_buttons
				//console.log(clone(store.state.user));
				if (
					this.table &&
					store.state.user.rules &&
					store.state.user.rules.database == "certaines tables"
				) {
					for (
						var i = 0;
						i < store.state.user.rules.database_tables.length;
						i++
					) {
						if (
							store.state.user.rules.database_tables[i].name ==
							this.table
						) {
							this.rules =
								store.state.user.rules.database_tables[i];
							break;
						}
					}

					if (!this.rules.read) {
						this.$router.push({ name: "profile" });
					}
				}

				this.list_actions = [];
				this.list_actions_head = [];

				if (this.client_details && this.client_details.tables) {
					for (
						var i = 0;
						i < this.client_details.tables.length;
						i++
					) {
						if (this.client_details.tables[i].name == this.table) {
							this.list_actions =
								this.client_details.tables[i].actions || [];
							this.list_actions_head =
								this.client_details.tables[i].actions_head ||
								[];
							this.column_id =
								this.client_details.tables[i].column_id || "id";
							this.$refs.main_data.set_index(this.column_id);
							this.description = this.client_details.tables[i].description
						}
					}
				}

				this.new_coluns = [];
				this.options_columns = [];
				this.update_columns = [];
				this.event = "";
				this.new_columns = [];
				this.columns_selected = [];
				this.select = "*";
				this.columns = await database_service.get("show", this.table, undefined, this.test_jwt);

				for (var i = 0; i < this.columns.length; i++) {
					var column = {
						id: "`" + this.columns[i].Field + "`",
						label: this.columns[i].Field,
						type: this.columns[i].Type,
					};
					var description = "";
					if (this.columns[i].Null == "NO")
						description += " , ne peut pas être null ";
					if (this.columns[i].Default != null)
						description +=
							" , valeur par default : " +
							this.columns[i].Default +
							" ";
					if (this.columns[i].Extra)
						description += " , extra : " + this.columns[i].Extra;
					this.new_columns.push({
						name: this.columns[i].Field,
						checked: false,
						value: "",
						description: description,
					});
					this.options_columns.push(this.columns[i].Field);

					column.type = column.type.split("(")[0];

					if (
						this.columns[i].Field != this.column_id 
					) {
						this.update_columns.push(this.columns[i].Field);
					}

					if (
						!(
							column.type == "string" ||
							column.type == "integer" ||
							column.type == "double" ||
							column.type == "date" ||
							column.type == "time" ||
							column.type == "datetime" ||
							column.type == "boolean"
						)
					) {
						switch (column.type) {
							case "int":
								column.type = "integer";
								break;
							case "float":
								column.type = "double";
								break;
							case "tinyint":
								column.type = "integer";
								break;
							case "tinyint":
								column.type = "integer";
								break;
							case "timestamp":
								column.type = "integer";
								break;
							default:
								column.type = "string";
						}
					}

					this.columns[i] = column;
				}

				var config = {
					filters: this.columns,
					icons: {
						add_group: "fas fa-plus-square",
						add_rule: "fas fa-plus-circle",
						remove_group: "fas fa-minus-square",
						remove_rule: "fas fa-minus-circle",
						error: "fas fa-exclamation-triangle",
					},
					operators: [
						{ type: "equal" },
						{ type: "not_equal" },
						{ type: "less" },
						{ type: "less_or_equal" },
						{ type: "greater" },
						{ type: "greater_or_equal" },
						{ type: "between" },
						{ type: "contains" },
						{ type: "not_contains" },
						{ type: "begins_with" },
						{ type: "ends_with" },
						{
							type: "is_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
						{
							type: "is_not_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
					],
				};

				if (rules)
					config.rules = rules

				try {
					$("#builder" + id).queryBuilder("destroy");
					self.rules_sql = "";
				} catch (err) {}

				//console.log(config)

				$("#builder" + id).queryBuilder(config);

				$("#builder" + id).on(
					"change",
					function (e, rule, error, value) {
						try {
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_editor = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.rules_sql = self.rules_sql;
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
							//console.log(self.rules_sql)
							//self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteRule.queryBuilder",
					function (e, rule, error, value) {
						try {
							self.rules_editor = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.rules_sql = " " + $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
							//self.updatePage();
						} catch (err) {
							self.rules_sql = "";
							self.rules_editor = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteGroup.queryBuilder",
					function (e, group) {
						try {
							self.rules_editor = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.rules_sql = " " + $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
						} catch (err) {
							self.rules_sql = "";
							self.rules_editor = "";
						}
					}
				);

				if (update)
				{
					//console.log("init update")
					await this.updatePage();
					await this.$nextTick();
					if (this.$refs.configSaveLoad) {
						this.$refs.configSaveLoad.reset();
						await this.$refs.configSaveLoad.autoLoad();
					}
				}

				this.setStructureData();
			},
			reset() {
				//console.log("reset")
				$("#builder" + this.id).queryBuilder("reset");
				this.rules_sql = "";
				this.updatePage();
			},
			dowloadCSV: function () {
				const tabulatorInstance = this.$refs.tabulator.getInstance();
				tabulatorInstance.download("csv", this.local_filename || this.filename);
			},
			dowloadExcel: function () {
				const tabulatorInstance = this.$refs.tabulator.getInstance();
				const base = (this.local_filename || this.filename || 'data').replace(".csv", "");
				tabulatorInstance.download(
					"xlsx",
					base + ".xlsx"
				);
			},
			dowloadJson: function () {
				const tabulatorInstance = this.$refs.tabulator.getInstance();
				const base = (this.local_filename || this.filename || 'data').replace(".csv", "");
				tabulatorInstance.download(
					"json",
					base + ".json",
					{ delimiter: ";" }
				);
			},
			async update(event) {
				this.columns_selected = event;
				//if (this.event.startsWith("doublons"))
				//this.updatePage();
			},
			async updatePage(event = null) {

				//console.log("updatePage")

				if (!this.table)
					return;

				var self = this;

				var pagination_size = 10;

				if (event !== null) this.event = event;
				else this.event = this.value_request;

				//console.log(this.event)

				this.text = "Requête en cours";

				if (
					!this.event ||
					this.event == "100 derniers" ||
					this.event == "no limit"
				) {
					var id = false;
					for (var i = 0; i < this.columns.length; i++) {
						if (this.columns[i].label == this.column_id) id = true;
					}
					this.request = this.rules_sql + " ";
					if (id)
						this.request += "ORDER BY " + this.column_id + " DESC ";
					if (this.event != "no limit") this.request += "LIMIT 100";

					this.data = await database_service.get("select", this.table, {
						select: this.select,
						end: this.request,
					}, this.test_jwt);
					this.count = await database_service.get("SELECT", this.table, {
						select: "count(*) AS count",
						end: this.request,
					}, this.test_jwt);

					this.text = "";
					if (!self.rules_sql)
						this.text =
							"Résultat : " +
							this.data.length +
							" lignes sur un total de " +
							this.count[0].count;
					else this.text = this.data.length + " lignes";

					this.tabulator_data = this.data;

					var fields = [];
					if (this.data > 0) fields = Object.keys(this.data[0]);
				} else if (this.event == "structure") {
					this.data = await database_service.get("show", this.table, undefined, this.test_jwt);
					this.text = "structure de la table";

					var exemple = await database_service.get("SELECT", this.table, {
						end: "ORDER BY id DESC LIMIT 1",
					}, this.test_jwt);
					if (exemple.length > 0) {
						exemple = exemple[0];

						for (var i = 0; i < this.data.length; i++) {
							this.data[i].Exemple = exemple[this.data[i].Field];
						}
					}

					this.tabulator_data = this.data;
					fields = [
						"Field",
						"Type",
						"Null",
						"Key",
						"Default",
						"Extra",
						"Comment",
						"Exemple",
					];

					pagination_size = 50;
				} else if (this.event.startsWith("doublons")) {
					this.columns_search = this.columns_selected;
					this.first_line = false;

					if (this.event.includes("premières"))
						this.first_line = true;

					if (this.columns_search.length == 0) {
						this.text = "Pas de colonnes id sélectionnée";
					} else {
						this.data = await database_service.get("select", this.table, {
							end: this.rules_sql,
						}, this.test_jwt);

						var data = {
							action: "doublons",
							parameters: {
								columns: this.columns_search,
							},
							file: this.data,
						};

						this.data = await workers.test(data);
						var keys = Object.keys(this.data.data.json);
						this.data = this.data.data.json[keys[0]];

						if (!this.data) {
							this.text = "Pas de données";
							this.data = [{}];
							this.text = "0 ligne";
						}
						else
						{
							this.text = this.data.length + " lignes";
						}

						this.tabulator_data = this.data;

						var fields = [];
						if (this.data > 0) fields = Object.keys(this.data[0]);
					}
				} else {
					var where = this.rules_sql + " ";
					if (this.event) {
						var end = this.event.toLowerCase().trim();
						if (
							this.rules_sql &&
							end &&
							!end.startsWith("limit") &&
							!end.startsWith("order by") &&
							!end.startsWith("group by")
						)
							where += "AND ";
						where += this.event;
					}
					this.data = await database_service.get("select", this.table, {
						select: this.select,
						end: where,
					}, this.test_jwt);

					this.text = this.data.length + " lignes";
					if (!this.data) {
						this.text = "Pas de données";
						this.data = [{}];
					}

					this.tabulator_data = this.data;

					var fields = [];
					if (this.data > 0) fields = Object.keys(this.data[0]);
				}

				this.$refs.main_data.set_data(this.tabulator_data);

				window.setInputMenu = this.setInputMenu;
				this.height = window.innerHeight;

				var headerContextMenu = [
					{
						label: "<input onChange='setInputMenu(this.value)' onClick='event.stopPropagation();'></input> Nouvelle valeur pour toute la colonne",
						action: function (e, column) {
							var name = column.getDefinition().field;
							for (
								var i = 0;
								i < self.tabulator_data.length;
								i++
							) {
								self.tabulator_data[i][name] = self.input_menu;
							}
						},
					},
				];

				var columns = [];
				for (var i = 0; i < fields.length; i++) {
					columns.push({
						title: fields[i],
						field: fields[i],
						editor: "textarea",
						headerContextMenu: headerContextMenu,
					});
				}

				this.local_filename = this.table + ".csv";
			},
			setInputMenu(input_menu) {
				this.input_menu = input_menu;
			},
		},
	};
</script>

<style lang="scss">
	.pre-formatted {
		white-space: pre-wrap;
	}
	.database {
		hr {
			border: 0;
		}
		h3 {
			margin-top: 2.5rem;
		}
		.tabulator {
			font-size: 0.8rem;
		}
	}
</style>
